import React from 'react';
import '../styles/Legal.css';
import usePageMeta from "../hooks/usePageMeta";

const LAST_UPDATED = 'January 9, 2026';

const CookiesPage: React.FC = () => {
  usePageMeta({
    title: "Cookies Notice | PabSync",
    description:
      "How PabSync uses cookies and similar technologies.",
    path: "/cookies",
  });

  return (
    <div className="legal-page">
      <main className="legal-container">
        <article className="legal-card">
          <h1 className="legal-title">Cookies Notice</h1>
          <p className="legal-meta">Last updated: {LAST_UPDATED}</p>

          <p>
            This page explains how PabSync uses cookies and similar technologies. “Cookies” are small text files stored
            by your browser. “Similar technologies” can include local storage, pixels, and device identifiers.
          </p>

          <h2>How we use cookies</h2>
          <ul>
            <li>
              <strong>Essential</strong>: required for core site/app functionality and security.
            </li>
            <li>
              <strong>Preferences</strong>: to remember settings (where applicable).
            </li>
            <li>
              <strong>Security</strong>: to help prevent abuse and protect the service (for example, via reCAPTCHA).
            </li>
          </ul>

          <h2>Your choices</h2>
          <p>
            Most browsers let you control cookies through settings. You can also clear local storage from your browser.
            If you disable cookies, parts of the site or app may not work correctly.
          </p>

          <h2>Third-party technologies</h2>
          <p>
            Some pages may load third-party services for security or payments. See <a href="/subprocessors">Subprocessors</a> for
            commonly used vendors.
          </p>

          <h2>Contact</h2>
          <p>
            Questions about cookies and privacy: <a href="mailto:datacare@pabsync.com">datacare@pabsync.com</a>
          </p>

          <p className="legal-note">
            This page is provided for general informational purposes and may be updated from time to time.
          </p>
        </article>
      </main>
    </div>
  );
};

export default CookiesPage;
